import * as React from "react";
import type { SVGProps } from "react";
const SvgPercent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.707 5.707a1 1 0 0 0-1.414-1.414zM4.293 18.293a1 1 0 1 0 1.414 1.414zm14-14-14 14 1.414 1.414 14-14zM8 6.5A1.5 1.5 0 0 1 6.5 8v2A3.5 3.5 0 0 0 10 6.5zM6.5 8A1.5 1.5 0 0 1 5 6.5H3A3.5 3.5 0 0 0 6.5 10zM5 6.5A1.5 1.5 0 0 1 6.5 5V3A3.5 3.5 0 0 0 3 6.5zM6.5 5A1.5 1.5 0 0 1 8 6.5h2A3.5 3.5 0 0 0 6.5 3zM19 17.5a1.5 1.5 0 0 1-1.5 1.5v2a3.5 3.5 0 0 0 3.5-3.5zM17.5 19a1.5 1.5 0 0 1-1.5-1.5h-2a3.5 3.5 0 0 0 3.5 3.5zM16 17.5a1.5 1.5 0 0 1 1.5-1.5v-2a3.5 3.5 0 0 0-3.5 3.5zm1.5-1.5a1.5 1.5 0 0 1 1.5 1.5h2a3.5 3.5 0 0 0-3.5-3.5z"
    />
  </svg>
);
export default SvgPercent;
